import * as yup from "yup";
import i18n from "i18next";
import { INPUT_LENGTH } from "@duosoftbg/nacid-components";

export const createReferenceDataFilterValidationSchema = () => {
  yup.setLocale({
    string: {
      matches: i18n.t("validation.field.invalid"),
    },
    mixed: {
      default: i18n.t("validation.field.invalid"),
    },
  });

  return yup.object().shape({
    isActive: yup.string(),
    index: yup.string(),
    name: yup.string().max(INPUT_LENGTH.MAX_INPUT_LENGTH_S, i18n.t("validation.charCount.invalid.200")),
    id: yup.string().max(INPUT_LENGTH.MAX_INPUT_LENGTH_S, i18n.t("validation.charCount.invalid.200")),
    domain: yup.string().max(INPUT_LENGTH.MAX_INPUT_LENGTH_S, i18n.t("validation.charCount.invalid.200")),
  });
};
